export default {
  calendar: {
    title: "Calendario regulatorio",
    subtitle: "Los ciclos que mueven el precio y la financiación en España, con sus próximas fechas. Las estimadas se marcan como tales.",
    errorLabel: "Error:",
    daysDeadline: "días de plazo",
    upcomingMilestones: "Próximos hitos",
    loading: "Cargando…",
    official: "Oficial",
    estimated: "Estimado",
    deadlineOpen: "Plazo abierto",
    today: "hoy",
    inDay: "en {n} día",
    inDays: "en {n} días",
    windowLabel: "Ventana:",
    recent: "Recientes",
    closed: "Cerrado",
    // Hitos previstos (R-22…R-26, §90 Fase 3)
    predictionsTitle: "Qué viene y qué no ha llegado",
    predictionsHint: "fechas que te afectan y hitos que se han pasado de plazo",
    predictionsEmpty: "Nada aquí. Las fechas nacen cuando ocurre un hito de origen con plazo conocido.",
    pred_cumplido: "Cumplidos",
    pred_cuenta_atras: "Cuenta atrás",
    pred_sin_llegar: "Sin llegar",
    predAll: "Todos",
    predOwn: "Míos",
    predRival: "De competidores",
    predUsual: "lo normal son {n} días · lleva {m}",
    predUsualUnknown: "lleva {m} días desde el origen",
    predHorizon: "Ventana",
    predHorizonMonths: "{n} meses",
    predCountdownHint: "fin de la exclusividad de datos, de la protección de mercado o de la exclusividad de huérfano, dentro de la ventana elegida",
    predLateHint: "hitos que una fuente debería haber confirmado y no ha confirmado",
    predDoneHint: "llegaron dentro de lo esperado",
    predPortfolio: "Portfolio",
    predCompetitor: "Competencia",
    predLate: "{n} días de retraso",
    predDoneOn: "Cumplido el {date}",
    predOrigin: "Tras «{hito}» ({date})",
    predBasisLegal: "plazo legal: {n} días",
    predBasisEmpirical: "plazo empírico: {n} días",
    // Ventanas de publicación (R-32 / C-07, §90 Fase 4D)
    pubTitle: "Próximas publicaciones esperadas",
    pubHint: "Cuándo suele publicar cada organismo. Si la ventana pasa sin fichero nuevo, lo avisamos: el silencio de una fuente no es la ausencia de novedades.",
    pubOpen: "ventana abierta",
    pubMissing: "sin publicar",
    pubOk: "publicado",
    pubNext: "Próxima ventana: {from} → {to}",
    pubMissingSince: "última ventana cerró el {date} sin fichero nuevo",
    monthsShort: "ene,feb,mar,abr,may,jun,jul,ago,sep,oct,nov,dic",
  },
};
